<template>
  <div v-bind:class="{'epub-viewer':!flashcardDeckEditor, 'epub-viewer-with-flashcard-editor':flashcardDeckEditor}">
    <iframe
      sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
      id="book-display"
      name="book-display"
      frameborder="0"
      v-on:load="onPageLoaded()"
      v-bind:class="{
        'book-display':!flashcardDeckEditor&!showSearchMode, 
        'book-display-with-flashcard-editor' : flashcardDeckEditor, 
        'book-display-with-search-active' : showSearchMode
      }"
      :src="pageSrc"
      class="book-scroller"
    ></iframe>
  </div>
</template>

<script>
const _ = require("lodash");
const moment = require("moment");
const prohibitCopyLength = 300;
require("moment-timezone");
moment.tz.setDefault("Africa/Johannesburg");

import Vue from "vue";
import utils from "@/utils/utils.js";
import bookUtils from "@/utils/bookUtils.js";
import epubUtils from "@/utils/epubUtils.js";
import storeHelpers from "@/utils/storeHelpers.js";
import { EPUB_NAV_VERSION } from "@/utils/constants";
import scroll from "@/directives/scroll";
import serverUtils from "@/utils/serverUtils.js";
import analytics from "@/utils/analytics.js";

import ContextMenu from "../annotations/ContextMenu";

window.cssZoom = function(level) {
  var bodyAndWindowHandles = bookUtils.getiFrame();
  var doc = bodyAndWindowHandles.documentHandle;

  if (!doc) return;
  if (!window.baseHeight) window.baseHeight = doc.body.scrollHeight;
  doc.body.style.zoom = level;
};

// $('body').css('webkitTextSizeAdjust', '' + zoom);

export default {
  name: "EpubViewer",
  components: {
    ContextMenu
  },
  data: function() {
    var t = this;

    return {
      pageSrc: "",
      debouncedScroll: _.debounce(this.onScroll, 100, { maxWait: 60000 }),
      tocCurrentPage: 0,
      contextMenu: {
        el: undefined,
        menuVisible: false
      },
      highlightsLoaded: false,
      mouseIsDown: false,
      debouncedSelect: _.debounce(this.debouncedFlashcardSelect, 300, {
        maxWait: 60000
      }),
      debouncedCheckToSearch: _.debounce( this.checkToSearch, 400, { 'maxWait': 60000 }),
      selection: ""
    };
  },
  directives: {
    scroll
  },
  props: {
    book: {
      type: Object,
      required: true
    },
    activePages: {
      type: Array,
      required: true
    },
    metadata: {
      type: Object,
      required: true
    },
    currentPage: {
      type: Object,
      required: true
    },
    scale: {
      type: Number,
      required: true
    },
    highlights: {
      type: Object,
      required: true
    },
    tocOpen: {
      type: Boolean,
      required: true
    },
    flashcardDeckEditor: {
      type: Boolean,
      required: true
    },
    showAnnotations: {
      type: Boolean,
      required: true
    },
    currentPageDisplay: {
      type: String,
      required: true
    },
    onPageLoading: Function,
    onCurrentPageChanged: Function,
    updatePrevChevron: Function,
    updateNextChevron: Function,
    contextMenuListItemOpen: Boolean,
    hlPenMode: {
      type: String,
      required: true
    },
    hlPenSettings: {
      type: Object,
      required: true
    },
    search: {
      type: String,
      required: true
    },
    showSearchMode : {
      type: Boolean,
      required: true
    },
    searchIndex : {
      type: Number,
      required: true
    },
    greetingSpeech: {
      required: false
    },
    selectedVoice: {
      required: false
    },
    synth: {
      required: false
    },
    voiceList: {
      required: false
    },
    textToSpeechRate: {
      required: false
    },
    textToSpeechVolume: {
      required: false
    }
  },
  watch: {
    currentPage: {
      immediate: true,
      handler(val, oldVal) {
        storeHelpers.checkActive(this);
        if (this.metadata) {
          this.loadCurrentPage();
        }
      }
    },
    scale: {
      immediate: true,
      handler(val, oldVal) {
        storeHelpers.checkActive(this);
        window.cssZoom(val / 100.0);
        this.recalculatePageYs();
      }
    },
    tocOpen: {
      immediate: true,
      handler(val, oldVal) {
        storeHelpers.checkActive(this);
        if (oldVal !== undefined) {
          this.tocCurrentPage = this.currentPage.oneBasedIndex;
          this.recalculatePageYs();
        }
      }
    },
    showAnnotations: {
      immediate: true,
      handler(val) {
        if (!this.highlightsLoaded) return;
        storeHelpers.checkActive(this);
        if (val) {
          this.restoreHL();
        } else {
          this.revertHL();
        }
      }
    },
    hlPenMode: {
      immediate: true,
      handler(mode) {
        var { documentHandle } = bookUtils.getiFrame();
        if (!documentHandle) return;

        storeHelpers.checkActive(this);

        if (mode === "highlighter") {
          documentHandle.body.classList.add("itsi-no-select");
        } else {
          documentHandle.body.classList.remove("itsi-no-select");
        }
      }
    },
    search: {
      immediate: true,
      handler (newVal, oldVal) {
        storeHelpers.checkActive(this);
        if (oldVal && oldVal !== "" && newVal === "") {
          var { windowHandle } = bookUtils.getiFrame();
          windowHandle.epubSearchRemoveAllHighlights();
        }
        if (this.showSearchMode) {
          this.debouncedCheckToSearch();
        }
      }
    }
  },
  mounted() {
    this.createContextMenuListener();
    var t = this;
    document.addEventListener("keydown", function(zEvent) {
      // if (zEvent.ctrlKey && zEvent.key === "z") {
      //   t.undo();
      // }
    });
    storeHelpers.checkActive(this);
  },
  beforeDestroyed() {
    this.cleanUp();
  },
  methods: {
    setFontColor() {
      var { documentHandle } = bookUtils.getiFrame();
      documentHandle.body.style.color = this.hlPenSettings.hlColor
    },
    createContextMenuListener: function() {
      var { windowHandle } = bookUtils.getiFrame();
      var t = this;
      t.contextMenu.el = document.querySelector(".menu");
      if (windowHandle.addEventListener) {
        // IE >= 9; other browsers
        windowHandle.addEventListener("contextmenu", t.contextMenuListener, false);
      } else {
        // IE < 9
        windowHandle.attachEvent("oncontextmenu", function() {
          t.contextMenu = false;
          windowHandle.event.returnValue = false;
        });
      }

      document.addEventListener("click", e => {
        if (t.contextMenu.menuVisible) {
          t.toggleContextMenu(false);
        }
      });
      windowHandle.addEventListener("click", e => {
        if (t.contextMenu.menuVisible) {
          t.toggleContextMenu(false);
        }
      });
    },
    toggleContextMenu: function(visible) {
      if (this.hlPenMode !== "highlighter") {
        this.contextMenu.el.style.display = visible && !this.contextMenuListItemOpen ? "inline-block" : "none";
        this.contextMenu.menuVisible = visible;
        var currentPageObject = bookUtils.getCurrentPageObject(this.metadata, this.currentPage);
        this.$emit("toggleContextMenu", {
          menuVisible: this.contextMenu.menuVisible,
          section: currentPageObject.file
        });
      }
    },
    setContextMenuPosition: function({ top, left }) {
      this.contextMenu.el.style.left = `${left}px`;
      this.contextMenu.el.style.top = `${top}px`;
      this.toggleContextMenu(true);
    },
    contextMenuListener: function(e) {
      e.preventDefault();
      const origin = {
        left: e.x + 4,
        top: e.y + 116
      };
      this.setContextMenuPosition(origin);
      var { windowHandle, documentHandle } = bookUtils.getiFrame();
      var selector = windowHandle.getSelectedStartSelector();

      this.revertHL();
      if (!selector) {
        selector = windowHandle.getSelectorAtPos(origin.left, origin.top);
      }
      this.restoreHL();

      this.$emit("contextMenuSelector", selector);

      // show where the selector is
      // if(this.$config.get('localServer')) {
      //   documentHandle.querySelector(selector).style.border = '1px solid red';
      // }

      return false;
    },
    async loadCurrentPage() {
      var t = this;

      storeHelpers.addPageOpened(t, t.book.id, t.currentPage.oneBasedIndex - 1, 1);
      // if the page was changed because of a scroll
      if (t.currentPage.method === "scroll") {}
      else {
        var currentPageObject = bookUtils.getCurrentPageObject(t.metadata, t.currentPage);
        var newPageSrc = t.$config.get("ecApi") + "web/books/epub/files/" + EPUB_NAV_VERSION + "/" + t.book._id + "/" + t.metadata.basePath + "/" + currentPageObject.file;
        if (t.currentPage.method === "default" || t.currentPage.method === "nextNavPage" || t.currentPage.method === "prevNavPage") {
          const isAvailable = await serverUtils.isEndpointAvailable(newPageSrc);
          if (!isAvailable.status || isAvailable.code !== 200) {
            // console.log("[pwa stuff] navigator state", navigator.serviceWorker.controller.state);
            // if (navigator.serviceWorker.controller.state !== "activated") {
            var messages = ["The page you requested is not available, please try again later.", "Warning: Webreader has detected smoke from your left mouse button.",
            '\"I think you should cycle between funny messages, but don\'t quote me\"',
            "You clicked a bit too fast for us to keep up, please wait a while and try again",
            "Daily click limit reached, please use your keyboard"]
            const randomElement = messages[Math.floor(Math.random() * messages.length)];
            t.$parent.onBookError(randomElement);
            return;
            // }
          }
        }
        if (newPageSrc !== t.pageSrc) {
          t.cleanUp();
          t.onPageLoading(true);
          t.pageSrc = newPageSrc;
        } else {
          bookUtils.scrollToY(currentPageObject.y, bookUtils.getiFrame(), 5, t.scale);
        }
      }

      // if there are active pages
      if (t.activePages.length > 0) {
        // if the flashcard editor is open
        if (t.flashcardDeckEditor) {
          var scroller = document.getElementsByClassName("book-scroller")[0].contentDocument.documentElement;
          if (scroller) {
            t.updatePrevChevron(scroller.scrollTop <= 0);
            t.updateNextChevron(Math.ceil(scroller.scrollTop + scroller.clientHeight) >= scroller.scrollHeight);
          }
        } else {
          t.updatePrevChevron(t.currentPage.oneBasedIndex === t.activePages[0].page);
          t.updateNextChevron(t.currentPage.oneBasedIndex === t.activePages[t.activePages.length - 1].page);
        }
      }
      setTimeout(() => {
        if (t.currentPage.method === "search" && t.searchIndex != -1) {
          var { documentHandle } = bookUtils.getiFrame();
          var elmnt = documentHandle.getElementsByClassName("epubSearchHighlight")[t.searchIndex];
          if (elmnt)
            elmnt.scrollIntoView();
        }  
      }, 50);
    },
    onScroll(event) {
      // use active pages
      // get containerElement
      var { documentHandle, windowHandle } = bookUtils.getiFrame();

      const yOffset = windowHandle.pageYOffset || documentHandle.scrollTop;
      var scrollTop = (yOffset ? yOffset : 0) - (documentHandle.clientTop || 0) / (this.scale / 100);
      var scrollHeight = documentHandle.body.scrollHeight / (this.scale / 100);

      // utils.log(this, scrollTop);

      if (this.activePages.length === 0) return;
      var newCurrentPage;

      // if at the bottom of the screen, assume last page
      if (Math.floor(windowHandle.innerHeight + windowHandle.scrollY) >= documentHandle.body.offsetHeight) {
        newCurrentPage = this.activePages[this.activePages.length - 1];
      } else {
        // look for which page is active
        for (var i = 1; i < this.activePages.length; i++) {
          if (this.activePages[i].y > scrollTop) {
            newCurrentPage = this.activePages[i - 1];
            break;
          }
        }
      }

      // if it was higher than the last page, assume the last page
      if (!newCurrentPage) {
        newCurrentPage = this.activePages[this.activePages.length - 1];
      }

      if (this.currentPage.oneBasedIndex !== newCurrentPage.page) {
        this.onCurrentPageChanged(newCurrentPage.page, "scroll");
      }
    },
    mouseDown(event) {
      if (event.button === 0) {
        if (this.hlPenMode === "highlighter") {
          this.mouseIsDown = true;

          const { windowHandle } = bookUtils.getiFrame();
          if (windowHandle && windowHandle.rthl && windowHandle.s2) {
            windowHandle.rthl.changeHLColor(this.hlPenSettings.hlColor);
            windowHandle.rthl.event(event.clientX, event.clientY);
          }
        } else if (this.hlPenMode === "textToSpeech") {
          this.mouseIsDown = true;
        }
      }
    },
    mouseMove(event) {
      if (event.button === 0) {
        if (this.hlPenMode === "highlighter") {
          if (this.mouseIsDown) {
            const { windowHandle } = bookUtils.getiFrame();
            if (windowHandle && windowHandle.rthl && windowHandle.s2) {
              windowHandle.rthl.event(event.clientX, event.clientY);
            }
          }
        } else if (this.hlPenMode === "textToSpeech") {
          this.mouseIsDown = true;
        }
      }
    },
    mouseUp(event) {
      var t = this;
      if (event.button === 0) {
        const { windowHandle } = bookUtils.getiFrame();
        if (this.hlPenMode === "highlighter") {
          this.mouseIsDown = false;
          if (windowHandle && windowHandle.rthl && windowHandle.s2) {
            windowHandle.rthl.finish(function(obj) {
              if ("undoEnabled" in obj) {
                t.$emit("updateUndo", obj.undoEnabled);
              }
              if ("textSelected" in obj) {
                // todo
              }
              if ("highlightUpdate" in obj) {
                t.hlUpdated(obj.highlightUpdate);
              }
            });
          }
        } else if (this.hlPenMode === "textToSpeech" && this.mouseIsDown && windowHandle.getSelection().toString().length > 0) {
          const { windowHandle } = bookUtils.getiFrame();
          this.synth.cancel()
          this.$emit("textToSpeech", false)
          var t = this
          this.greetingSpeech.onend = () => {
            t.$emit("textToSpeech", false)
          } 
          this.greetingSpeech.text = windowHandle.getSelection().toString()
          this.greetingSpeech.voice = this.voiceList[this.selectedVoice]
          this.greetingSpeech.rate = this.textToSpeechRate / 10
          this.greetingSpeech.volume = this.textToSpeechVolume / 10
          this.synth.speak(this.greetingSpeech)
          this.$emit("textToSpeech", true)

          this.mouseIsDown = false;
        }
      }
    },
    onTextSelect(event) {
      const { windowHandle } = bookUtils.getiFrame();
      this.selection = windowHandle.getSelection().toString();
      if (this.flashcardDeckEditor) {
        this.debouncedSelect();
      }
    },
    debouncedFlashcardSelect() {
      this.$emit("flashcardOnSelect", this.selection);
    },
    onPageLoaded: function() {
      var t = this;
      t.onPageLoading(false);
      Vue.nextTick(function() {
        t.$parent.$refs.resourcePanel.setEpubInstance();
        t.calculatePageYs();
        var { documentHandle } = bookUtils.getiFrame();
        if (documentHandle) {
          documentHandle.addEventListener("scroll", t.debouncedScroll, false);
          documentHandle.addEventListener("copy", t.prohibitCopy);
          documentHandle.body.addEventListener("mousedown", t.mouseDown);
          // documentHandle.addEventListener("touchstart", t.mouseDown);
          documentHandle.body.addEventListener("mousemove", t.mouseMove);
          documentHandle.body.addEventListener("mouseup", t.mouseUp);
          // documentHandle.addEventListener("touchend", t.mouseUp);
          documentHandle.addEventListener("selectionchange", t.onTextSelect);
          // documentHandle.addEventListener("keydown", function(zEvent) {
          //   if (zEvent.ctrlKey && zEvent.key === "z") {
          //     t.undo();
          //   }
          // });
        }
        if (t.hlPenMode === "highlighter") {
          documentHandle.body.classList.add("itsi-no-select");
        }
        var currentPageObject = bookUtils.getCurrentPageObject(
          t.metadata,
          t.currentPage
        );

        // if not first page scroll to it
        if (t.activePages.length > 0 && currentPageObject.page !== t.activePages[0].page) {
          bookUtils.scrollToY(
            currentPageObject.y,
            bookUtils.getiFrame(),
            5,
            t.scale
          );
        }

        t.createContextMenuListener();
      });

      if (this.flashcardDeckEditor) {
        this.updatePrevChevron(true);
      } else {
        if (
          this.activePages.length > 0 &&
          this.currentPage.oneBasedIndex === this.activePages[0].page
        ) {
          this.updatePrevChevron(true);
        }
        if (
          this.activePages.length > 0 &&
          this.currentPage.oneBasedIndex ===
            this.activePages[this.activePages.length - 1].page
        ) {
          this.updateNextChevron(true);
        }
        this.initPageScripts();
        this.detectNavigation();
      }      
      this.$emit("loadTime", moment().valueOf());
    },
    detectNavigation: function() {
      this.$emit("setPagePrev", false);
      this.$emit("setPageNext", false);
      if (this.activePages.length > 0 && this.currentPage.oneBasedIndex === this.activePages[0].page) {
        this.$emit("setPagePrev", true);
      }
      if (this.activePages.length > 0 && this.currentPage.oneBasedIndex === this.activePages[this.activePages.length - 1].page) {
        this.$emit("setPageNext", true);
      }
    },
    initPageScripts() {
      // utils.log(this, "Loading scripts and highlights");
      var t = this;

      var currentPageObject = bookUtils.getCurrentPageObject(
        t.metadata,
        t.currentPage
      );
      if (!currentPageObject || !currentPageObject.file) return;

      var { documentHandle, windowHandle } = bookUtils.getiFrame();

      const path = t.$config.get("localServer") ? "https://app.dev.it.si/reader/" : t.$config.get("basePathFiles");
      epubUtils.injectJSFile(documentHandle, path + "static/scripts/jquery.js");
      epubUtils.injectCSSFile(documentHandle, path + "static/styles/epub-itsi-styles.css");

      // utils.log(this, "Checking that scripts are loaded");
      // on jquery loaded
      t.checkJqueryLoaded(windowHandle, function() {
        epubUtils.injectJSFile(documentHandle, path + "static/scripts/epub-hl.js");
        epubUtils.injectJSFile(documentHandle, path + "static/scripts/reader.js");
        epubUtils.injectCSSFile(documentHandle, path + "static/styles/mobile.css");

        // on hl library loaded
        t.checkRTHLLoaded(windowHandle, function() {
          // on other reader stuff loaded
          t.checkReaderJSLoaded(windowHandle, function() {
            // load highlights
            var hlForThisPage = t.highlights[currentPageObject.file];
            windowHandle.s2.buildCache();
            windowHandle.rthl.restore(
              JSON.stringify(hlForThisPage ? hlForThisPage.content : {}),
              function(obj) {
                if ("undoEnabled" in obj) {
                  t.$emit("updateUndo", obj.undoEnabled);
                }
              }
            );

            t.highlightsLoaded = true;

            if (!t.showAnnotations) {
              t.revertHL();
            }
          });
        });
      });
      if (this.showSearchMode) {
        this.debouncedCheckToSearch();
      }
    },
    checkJqueryLoaded(windowHandle, callback) {
      var t = this;

      if (windowHandle.$) {
        // utils.log(this, "jquery.js loaded");
        callback();
      } else {
        setTimeout(function() {
          t.checkJqueryLoaded(windowHandle, callback);
        }, 100);
      }
    },
    checkRTHLLoaded(windowHandle, callback) {
      var t = this;

      if (windowHandle.rthl) {
        // utils.log(this, "rthl.js loaded");
        callback();
      } else {
        setTimeout(function() {
          t.checkRTHLLoaded(windowHandle, callback);
        }, 100);
      }
    },
    checkReaderJSLoaded(windowHandle, callback) {
      var t = this;

      if (windowHandle.readerLoaded === "itsi") {
        // utils.log(this, "reader.js loaded");
        callback();
      } else {
        setTimeout(function() {
          t.checkReaderJSLoaded(windowHandle, callback);
        }, 100);
      }
    },
    restoreHL: function() {
      const { windowHandle } = bookUtils.getiFrame();
      if (windowHandle && windowHandle.rthl && windowHandle.s2) {
        windowHandle.rthl.restoreDOM();
      }
    },
    revertHL: function() {
      const { windowHandle } = bookUtils.getiFrame();
      if (windowHandle && windowHandle.rthl && windowHandle.s2) {
        windowHandle.rthl.revert();
      }
    },
    undo: function() {
      var t = this;
      if (this.hlPenMode === "highlighter") {
        const { windowHandle } = bookUtils.getiFrame();
        if (windowHandle && windowHandle.rthl && windowHandle.s2) {
          windowHandle.rthl.undo(function(obj) {
            // utils.log(t, obj);
            if ("undoEnabled" in obj) {
              t.$emit("updateUndo", obj.undoEnabled);
            }
            if ("highlightUpdate" in obj) {
              t.hlUpdated(obj.highlightUpdate);
            }
          });
        }
      }
    },
    redo: function() {
      // only for pen mode, not in epubs
    },
    hlUpdated: function(hlData) {
      var currentPageObject = bookUtils.getCurrentPageObject(
        this.metadata,
        this.currentPage
      );
      // existing hl
      if (this.highlights[currentPageObject.file]) {
        this.highlights[currentPageObject.file].content = JSON.parse(hlData);

        // highlight: function(handle, hlId, bookId, section)
      } else {
        // new hl
        var t = this;
        this.highlights[currentPageObject.file] = {
          content: JSON.parse(hlData),
          book: this.book.id,
          section: currentPageObject.file,
          version: 2,
          selector: "",
          hash: bookUtils.constructHLId(currentPageObject.file, t.book.id)
        };

        // add it to the store temporarily (until next sync)
        storeHelpers.addHighlight(this, this.highlights[currentPageObject.file]);
      }

      analytics.highlight(this, this.highlights[currentPageObject.file]._id, this.book.id, this.highlights[currentPageObject.file].section
      );

      const hlWithNoObservers = JSON.parse(
        JSON.stringify(this.highlights[currentPageObject.file])
      );

      storeHelpers.addItemToSync(this, {
        url: this.$config.get("ecApi") + "highlights2",
        method: "post",
        data: {
          book: hlWithNoObservers.book,
          section: hlWithNoObservers.section,
          content: hlWithNoObservers.content
        }
      });
    },
    calculatePageYs: function() {
      var t = this;

      var bodyAndWindowHandles = bookUtils.getiFrame();
      var doc = bodyAndWindowHandles.documentHandle;

      // utils.removeElementsByClass('itsi-page-line-dev-mode', doc);

      this.revertHL();

      _.each(t.activePages, function(page) {
        page.y = utils.getYFromSelector(t, page.selector, bodyAndWindowHandles);

        // if(t.$config.get('localServer')) {
        // add an indicator line (for dev purposes only)
        //   var pageLineElement = doc.createElement("div")
        //   pageLineElement.classList.add("itsi-page-line-dev-mode");
        //   pageLineElement.style.cssText = "width: 80%; height: 3px; color: red; background: red; position: absolute; top: " + page.y + "px;";
        //   pageLineElement.innerHTML = page.title + " - " + page.y;
        //   doc.body.append(pageLineElement);
        // }
      });

      this.restoreHL();
    },
    recalculatePageYs: function(timeout) {
      var t = this;
      var currentPageObject = bookUtils.getCurrentPageObject(this.metadata, this.currentPage);

      setTimeout(() => {
        t.calculatePageYs();
        bookUtils.scrollToY(currentPageObject.y, bookUtils.getiFrame(), 5, t.scale);
      }, timeout);
    },
    cleanUp: function() {
      var { documentHandle } = bookUtils.getiFrame();
      var t = this;
      if (documentHandle) {
        documentHandle.removeEventListener("scroll", t.debouncedScroll);
        documentHandle.removeEventListener("copy", t.prohibitCopy);
        documentHandle.body.removeEventListener("mousedown", t.mouseDown);
        // documentHandle.removeEventListener("touchstart", t.mouseDown);
        documentHandle.body.removeEventListener("mousemove", t.mouseMove);
        documentHandle.body.removeEventListener("mouseup", t.mouseUp);
        // documentHandle.removeEventListener("touchend", t.mouseUp);
        documentHandle.removeEventListener("selectionchange", t.onTextSelect);
        // documentHandle.removeEventListener("keydown", function(zEvent) {
        //   if (zEvent.ctrlKey && zEvent.key === "z") {
        //     t.undo();
        //   }
        // });
        // document.removeEventListener("keydown", function(zEvent) {
        //   if (zEvent.ctrlKey && zEvent.key === "z") {
        //     t.undo();
        //   }
        // });
      }
    },
    prohibitCopy: function(event) {
      var iframe = document.getElementById("book-display");
      var selection = iframe.contentWindow.getSelection(), 
      selectionString = selection.toString(), 
      pagelink = "<br /><br /> Read more at: " + document.location.href,
      newdiv = iframe.contentWindow.document.createElement("div");
      var copytext = selection;
      if (selectionString.length > prohibitCopyLength) {
        selectionString = selectionString.substring(0, prohibitCopyLength);
        copytext = selectionString + pagelink;
      }
      newdiv.style.position = "absolute";
      newdiv.style.left = "-99999px";
      iframe.contentWindow.document.body.appendChild(newdiv);
      newdiv.innerHTML = copytext;
      selection.selectAllChildren(newdiv);
      window.setTimeout(function() {
        iframe.contentWindow.document.body.removeChild(newdiv);
      }, 100);
    },
    checkToSearch: function() {
      var t = this;
      var { windowHandle } = bookUtils.getiFrame();
      if (t.search.length > 2) {
        var url = t.$config.get('ecApi') + "web/books/" + t.book.id + "/search?q=" + t.search;
        axios.get(url)
        .then(response => {
          var searchpage = "";
          var count = 0; 
          _.each(response.data, searchResult => {
            if (searchpage === searchResult.file) {
              count += 1;
              searchResult.index = count;
            } else {
              count = 0;
              searchpage = searchResult.file;
              searchResult.index = count;              
            }
          })         
          
          // get epub page ranges
          _.each(response.data, search => {
            var file = search.file.replace(this.metadata.basePath, '');
            file = file.replace("/", '');
            search.pageRange = bookUtils.getMPUBPageRange(this.metadata, file);
          })

          //sort results ascending by pageRange and then by index
          utils.log(t,"response:", response)
          if (response.data) {
            response.data.sort((a, b) => a.pageRange[0] > b.pageRange[1] ? 1 : (a.pageRange[0] === b.pageRange[0]) ? ((a.pageRange[0] < b.pageRange[1]) ? 1 : -1) : -1);
          } else {
            t.$emit("searchResults", response.data);
          }

          if (response.data.length > 200) {
            t.$emit("searchResults", response.data.splice(0, 200));
          } else {
            t.$emit("searchResults", response.data);
          }
        })
        .catch(e => {
          console.error("Error:", e);
        }) 
        windowHandle.epubSearchHighlightAllOccurencesOfString(t.search);
        if (t.currentPage.method === "search" && t.searchIndex != -1) {
          var { documentHandle } = bookUtils.getiFrame();
          var elmnt = documentHandle.getElementsByClassName("epubSearchHighlight")[t.searchIndex];
          if (elmnt)
            elmnt.scrollIntoView();
        }
      } else {
        windowHandle.epubSearchRemoveAllHighlights();
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "src/css/vars.scss";

.book-display {
  width: 100%;
  height: calc(100vh - 169px);
}

.book-display-with-flashcard-editor {
  width: 100%;
  height: calc(100vh - 403px);
}

.epub-viewer {
  margin-top: 52px;
  height: 100%;
}

.epub-viewer-with-flashcard-editor {
  margin-top: 0;
  height: 100%;
}

.book-display-with-search-active {
  width: 100%;
  height: calc(100vh - 209px);
  margin-top: 40px;
}
</style>